import type { WorkspaceMetadata } from '@toeverything/infra';
import {
  useLiveData,
  useService,
  WorkspacesService,
} from '@toeverything/infra';
import { useEffect } from 'react';

export function useWorkspaceInfo(meta?: WorkspaceMetadata) {
  const workspacesService = useService(WorkspacesService);

  const profile = meta ? workspacesService.getProfile(meta) : undefined;
  const profileData = useLiveData(profile?.profile$);

  useEffect(() => {
    if (!profile) {
      return undefined;
    }

    profile.revalidate();

    if (!profileData?.name) {
      const timer = setInterval(() => {
        if (!profile.profile$.value?.name && !profile.isLoading$.value) {
          profile.revalidate();
        }
      }, 500);

      return () => clearInterval(timer);
    }
    return undefined;
  }, [meta, profile, profileData]);

  return profileData;
}

export function useWorkspaceName(meta?: WorkspaceMetadata) {
  const information = useWorkspaceInfo(meta);

  return information?.name;
}
